/* jshint esversion: 6 */
import * as _ from 'underscore';

export default function SortModule(list, key, direction) {
	let search = (item) => {
    		let path = key.split("."),
    			target = item,
    			i = 0;

    		for (i = 0; i < path.length; ++i) {
    			if (target[path[i]]) {
    				target = target[path[i]];
    			} else {
    				return 0;
    			}
    		}

			if (_.isString(target)) {
				if (target.match(/[\d]+-[\d]+-[\d]+/)) {
	    			return new Date(target).getTime();
	    		} else {
					return target.toLowerCase();
				}
			}

    		return target;

    	},
        sortedList = list;

	// for last post or active: first sort by id so we have a kind of stable sort
	if (key.match('lastPost') || key.match('active')) {
		sortedList = _.sortBy(sortedList, 'id');
	}
	if (!key.match('psID')) {
		sortedList = _.sortBy(sortedList, search);
	} else {
		sortedList = [];
		let groupList = _.groupBy(list, (item) => {
				return item.psID;
			}),
			groupSort = [
				2, // POST_SVC_FACEBOOK
				1, // POST_SVC_TWITTER
			    8, // POST_SVC_INSTAGRAM_BUSINESS
                            38, // POST_SVC_TIKTOK

				20, // POST_SVC_GMYBUSINESS
				4, // POST_SVC_LINKEDIN
				5, // POST_SVC_PINTEREST
				30, // POST_SVC_BLOGGER
				24, // POST_SVC_DISCORD
				37, // POST_SVC_MASTODON
				36, // POST_SVC_REDDIT
				7, // POST_SVC_FEED
				23, // POST_SVC_SLACK
				22, // POST_SVC_STOCKTWITS
				3, // POST_SVC_TUMBLR
			    35, // POST_SVC_WORDPRESS
			];

		for (let index in groupSort) {
			let svcKey = groupSort[index];
			if (groupList[svcKey] !== undefined) {
				for (let i = 0; i < groupList[svcKey].length; ++i) {
					sortedList.push(groupList[svcKey][i]);
				}
			}
		}
	}

	if (direction === 'DESC') {
		sortedList.reverse();
	}

    return sortedList;

}
